import { useProduct } from '../../contexts/ProductContext';

/**
 * Tema visual do e-mail, o mesmo do backend (email.service.ts). O tema da
 * DocuGen trava as cores dos blocos na identidade visual da marca.
 */
export type EmailThemeId = 'default' | 'docugen';

const THEME_BY_PRODUCT_SLUG: Record<string, EmailThemeId> = {
  docugen: 'docugen',
};

export function emailThemeForSlug(slug: string | null | undefined): EmailThemeId {
  return (slug && THEME_BY_PRODUCT_SLUG[slug]) || 'default';
}

/** Tema do produto informado, ou do produto selecionado no seletor. */
export function useEmailTheme(productId?: number | null): EmailThemeId {
  const { products, selectedProductId } = useProduct();
  const id = productId ?? selectedProductId;
  return emailThemeForSlug(products.find((p) => p.id === id)?.slug);
}

/** No tema da DocuGen, cor de botão, subtítulo e divisor vem da identidade. */
export function themeLocksColors(theme: EmailThemeId): boolean {
  return theme === 'docugen';
}
